import React from "react"

import { Wrapper, StyledGrid, StyledCard, OneCardTitle } from "./styles"

const AuthorClasses = ({ classes, author }) => (
  <Wrapper>
    {classes.length > 1 ? (
      <StyledGrid
        title="Classes"
        numColumns={{ default: 3, desktopL: 3, desktop: 2, tablet: 2, mobile: 1 }}
        rowMargin="2.2rem"
        colMargin="2.6rem"
      >
        {classes.map((item) => (
          <StyledCard
            inline
            noClassShortIcon
            multiple
            key={item.id}
            headline={item.title}
            imageUrl={`//res.mindbodygreen.com/${item.image.path}`}
            instructorByline={item.instructorByline}
            url={item.url}
            localLink
            lazyLoadImage
            isGrid
          />
        ))}
      </StyledGrid>
    ) : (
      <>
        <OneCardTitle>Learn from {author.name}</OneCardTitle>
        <StyledCard
          inline
          noClassShortIcon
          key={classes[0].id}
          headline={classes[0].title}
          headlineVariant="large"
          imageUrl={`//res.mindbodygreen.com/${classes[0].image.path}`}
          instructorByline={classes[0].instructorByline}
          url={classes[0].url}
          localLink
          lazyLoadImage
        />
      </>
    )}
  </Wrapper>
)

export default AuthorClasses
